import React, { MutableRefObject, ReactNode } from 'react';
import { VirtualItem } from 'react-virtual';
import { Box, BoxProps } from '../../../../../wag-react/next-components/box';
export type VirtualItemWrapperProps = BoxProps & {
  virtualRow: VirtualItem;
  children: ReactNode;
};
export const VirtualItemWrapper = ({
  virtualRow,
  children,
  ...rest
}: VirtualItemWrapperProps) => <Box key={virtualRow.index} ref={virtualRow.measureRef as unknown as MutableRefObject<HTMLDivElement>} position="absolute" top={0} left={0} width={1} style={{
  transform: `translateY(${virtualRow.start}px)`
}} {...rest} data-sentry-element="Box" data-sentry-component="VirtualItemWrapper" data-sentry-source-file="DailyWagArticleCommentVirtualItemWrapper.tsx">
    {children}
  </Box>;